const loginMessages = {
  'login.button.name': 'ログイン',
  'login.oauth2.button.name': 'CIOSでログイン',
  'login.oauth2.error.unknown': 'ログインエラーです',
  'login.oauth2.error.601': '["ログインに失敗しました"]',
  'login.oauth2.error.602': '["企業コードが見つかりませんでした"]',
  'login.oauth2.error.603':
    '["企業に所属していないためログインできません。", "企業アカウントでご利用ください"]',
  'login.oauth2.error.1103':
    '["ライセンス数を超過しているためログインできません", "管理者にお問い合わせください"]',
  'login.oauth2.error.1104':
    '["アカウントが無効のためログインできません", "管理者にお問い合わせください"]',
  'login.oauth2.error.1005':
    '["ユーザライセンス数が不足しています。", "販売元へお問い合わせください。"]',
  'login.oauth2.button.logout': 'ログインページに戻る',
  'logout.oauth2.button.name': 'CIOSからログアウト',
  'login.oauth2.noUser': 'ユーザ情報がありません。ログインしてください。',
};

export default loginMessages;
